module.exports = __webpack_public_path__ + "static/img/hs_cj_3.c9260bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hs/hs_cj_3.png
// module id = hc/m
// module chunks = 1